module.exports = __webpack_public_path__ + "img/zw.zw3a3eb0f.svg";